<template>
    <div class="template8-house-swiper" 
         v-if="result.listings && result.listings.length > 0"
    >
        <Swiper
            v-bind="swiperOption"
            @observerUpdate="contentUpdated"
        >
            <Slide v-for="item in result.listings" :key="item.id">
                <house :house="item" />
            </Slide>
        </Swiper>
        <div class="button-swiper" v-if="!isMobileSize">
            <div class="house-prev iconfont icon-arrow-up"></div>
            <div class="house-next iconfont icon-arrow-up"></div>
        </div>
    </div>
</template>
<script>
import house from './house.vue';
import list from '../list.js';
import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';
export default {
    computed: {
        swiperOption({ isMobile, topSwiperOption, result }) {
            let defaultSwiperOption = {
                slidesPerView: 'auto',
                loop: result.listings?.length <= 3 ? false : true,
                navigation: {
                    closest: '.md-house',
                    nextEl: '.house-next',
                    prevEl: '.house-prev',
                    disabledClass: 'house-swiper-disabled'
                },
                direction: 'horizontal',
                centeredSlides: true,
                centeredSlidesBounds: false,
                spaceBetween: 0,
                effect: 'coverflow',
                initialSlide: 0,
                observer: true,
                coverflowEffect: {
                    rotate: 0,
                    depth: 0,
                    scale: isMobile ? 0.933 : 0.9,
                    slideShadows: false
                }
            };
            if (topSwiperOption) {
                Object.assign(defaultSwiperOption, topSwiperOption());
            }
            // console.log('============', defaultSwiperOption);

            if (isMobile) {
                return fixSwiperOptions({
                    ...defaultSwiperOption,
                    slidesPerView: 'auto',
                    spaceBetween: 0
                });
            } else {
                return fixSwiperOptions(defaultSwiperOption);
            }
        }
    },
    components: {
        house,
        Swiper,
        Slide: SwiperSlide
    },
    mixins: [list],
    methods: {
        contentUpdated(swiper) {
            if (this.resultUpdated) {
                swiper.slideNext();
                this.resultUpdated = false;
            }
        }
    },
};
</script>
<style lang="scss"></style>
